import React, { Component } from 'react'
import Loader from '../Common/Loader';
import { Link } from 'react-router-dom'
import constant from '../../constant';
import { onChange, validateForm } from '../../utils';
import fgt01 from '../../assets/images/back-arrow.png'
import com01 from '../../assets/images/meesho.png'
import com02 from '../../assets/images/amazon.png'
import com03 from '../../assets/images/mmt.png'
import com04 from '../../assets/images/mobikwik.png'
import com05 from '../../assets/images/swiggy.png'
import com06 from '../../assets/images/paytm.png'
import com07 from '../../assets/images/ola.png'
import work01 from '../../assets/images/one.svg'
import work02 from '../../assets/images/two.svg'
import work03 from '../../assets/images/three.svg'
import work04 from '../../assets/images/illustration-1.png'
import work05 from '../../assets/images/illustration-2.png'
import work06 from '../../assets/images/illustration-3.png'

export default class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            EMAIL: { name: "EMAIL", value: '', error: '', isRequired: true }
        }
    }

    onSubmit = (e) => {
        debugger
        e.preventDefault()
        if (validateForm(this)) {
            this.props.onSubmit({ EMAIL: this.state.EMAIL.value })
        }
    }
    onChange = (e) => {
        const { name, value } = e.target;
        onChange(this, name, value)
    }
    render() {
        const { EMAIL } = this.state;
        return (
            <React.Fragment>
                {this.props.showLoader && <Loader />}
                <div className="introduction__container">
                    <div className="introduction__container--header">
                        <div className="tagline">
                            <h5 style={{ color: '#008bd2' }}>
                                JobzShala Hiring Services for Employers
                            </h5>
                        </div>
                        {/* <h4 className="title"> */}
                        <h4 >

                            Linking campus talent to senior-level success stories
                            {/* Hire great <span>tech</span> talent */}
                        </h4>
                        <p className='subtitle'>
                            Unleash the power of Jobzshala and transform your hiring process. Discover, connect, and hire top-notch talent in a matter of days, bringing your recruitment game into the future.
                            {/* JobzShala is a high-end technology recruitment platform that offers a wide range of services for hiring. Employers can effortlessly post job listings without any charges and gain access to an extensive pool of top-notch candidates from leading companies in various tech fields like backend development, frontend development, product management, data analytics, and more. */}
                        </p>
                        <img style={{ width: '60%' }}
                            src='/assets/images/hiring-dash.png'
                        />
                    </div>
                    <form className="reset__wrapper" data-testid="forgot-password-form" onSubmit={this.onSubmit}>
                        <div className="btn_back" data-testid="btn-back">
                            <Link to={constant.component.login.url}>
                                <img src={fgt01} className="btn-back" alt="" /> Back
                                to login
                            </Link>

                        </div>
                        <div className="heading">Reset your password</div>
                        <div className="subHeading">
                            To obtain a new password, please enter your e-mail address and a link will
                            be emailed to you.
                        </div>
                        <div className="form__container">
                            <div className="formgroup">
                                <div className="r-input new input-email">
                                    <label htmlFor="input-email">Enter Email id</label>
                                    <div className="r-input-wrapper">
                                        <input
                                            className=" "
                                            type="email"
                                            name={EMAIL.name}
                                            value={EMAIL.value}
                                            onChange={this.onChange}
                                            id="input-email"
                                            placeholder="ex. john.smith@gmail.com"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className="r-button-wrapper btn-reset">
                            <button className="r-button  btn-reset " type='submit' data-testid="btn-reset">
                                Send Reset Email
                            </button>
                        </span>
                    </form>

                </div>
                <section className='companies-section'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='heading-box'>
                                    <h3>Top tech companies hiring on jobzShala.com</h3>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='companies-box'>
                                    <div className='logo-item'><img src={com01} /></div>
                                    <div className='logo-item'><img src={com02} /></div>
                                    <div className='logo-item'><img src={com03} /></div>
                                    <div className='logo-item'><img src={com04} /></div>
                                    <div className='logo-item'><img src={com05} /></div>
                                    <div className='logo-item'><img src={com06} /></div>
                                    <div className='logo-item'><img src={com07} /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section className="hero-wrapper hero-wrapper-3">
                    <div className="hero-overlay"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="hero-content-wrapper">
                                    <div className="hero-heading">
                                        <div className="section-heading">
                                            <h2 className="head_sec__title">JobzShala <span>Recruitment Services</span> for Employers</h2>
                                            <p className="sec__cupas">For <span>Campus</span> to Leadership</p>
                                           
                                        </div>
                                    </div>
                                    <div className='rozgarjonbox'>
                                        <ul>
                                            <li>JobzShala</li>
                                            <li>Firstjob</li>

                                            <li>Premuim Jobs </li>
                                            <li>Employer Branding</li>
                                        </ul>
                                    </div>
                                    <div className='bannerslider'>
                                        <img src={homeslie01} alt="blog image" class="img-fluid" />
                                    </div>

                                    


                                    <div className="btn-box margin-top-20px">
                                        <a href={constant.component.JobPosting.url} className="theme-btn mr-2">Read More <i className="la la-arrow-right"></i></a>
                                       
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="hero-form-wrap position-relative">
                                    <div className="billing-form-item">
                                        <div className="billing-title-wrap pb-2">
                                            <h3 className="widget-title pb-0">Login/Register</h3>
                                            <div className="title-shape margin-top-10px"></div>
                                        </div>
                                        <div className="billing-content">
                                            <div className="contact-form-action">
                                                <form onSubmit={this.onSubmit}>
                                                    <div className="input-box">
                                                        <label className="label-text">Registered Email ID</label>
                                                        <div className="form-group">
                                                            <span className="la la-user form-icon"></span>
                                                            <input
                                                                className={EMAIL.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                                type="email"
                                                                name={EMAIL.name}
                                                                value={EMAIL.value}
                                                                onChange={this.onChange}
                                                                placeholder="Registered Email ID" />
                                                        </div>
                                                    </div>
                                                    <div className="input-box">
                                                        <label className="label-text">Password</label>
                                                        <div className="form-group">
                                                            <span className="la la-lock form-icon"></span>
                                                            <input
                                                                className={PASSWORD.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                                type={showPassword ? 'text' : 'password'}
                                                                name={PASSWORD.name}
                                                                value={PASSWORD.value}
                                                                onChange={this.onChange}
                                                                placeholder="Password" />
                                                            {PASSWORD.value.length > 0 && <i onClick={() => { this.setState({ showPassword: !showPassword }) }} className={showPassword ? 'fa fa-fw fa-eye toggle-password field-icon' : 'fa fa-fw fa-eye-slash toggle-password field-icon'} style={{ cursor: 'pointer', color: '#868d8f', right: "24px" }}></i>}
                                                        </div>
                                                    </div>
                                                    <div className="input-box">
                                                        <div className="custom-checkbox mr-0 d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <input type="checkbox" onClick={this.onRemeberMeChange} checked={REMEMBER_ME} id="chb1" />
                                                                <label for="chb1">Keep me logged in</label>
                                                            </div>
                                                            <div>
                                                                <Link to={constant.component.ForgotPassword.url} className="color-link">Forgot password?</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="btn-box text-center">
                                                        <button className="login-btn border-0 w-100 text-center" type="submit" id='linked-in'>LOGIN</button>
                                                    </div>
                                                    <div className="input-box">
                                                        <div className="custom-checkbox mt-2 d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <label >Have a Query? <a target='_blank' href={constant.component.SalesEnquiry.url}>Contact Us</a></label>
                                                            </div>
                                                            <div>
                                                                <a href="https://jobzshala.com/report-a-problem" className="color-link">Fraud Alert!</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className='lineh' />
                                                    <div className="input-box">
                                                        <div className="custom-checkbox mt-1 d-flex align-items-center justify-content-between">
                                                            <div>
                                                                <label>Are you a new client ?</label>
                                                            </div>
                                                            <div>
                                                                <Link id='linked-in' to={constant.component.Register.url} className="register-btn border-0 w-100 text-center" type="submit">Register Now</Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hero-shape"></div>
                </section> */}
                {/* <!-- ================================
                                END HERO-WRAPPER AREA
                ================================= --> */}

                {/* <!-- ================================
                    START TAG AREA
                ================================= --> */}
                <div className="tag-area padding-top-40px padding-bottom-40px">
                    <div className="container">

                        <div className="row">

                            <div className="col-lg-6 ml-auto ">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-heading two-20">
                                            <p className='font-size-20 pb-3'>Products & Services</p>
                                            <h2 className="sec__title mb-0 line-height-30 font-size-25">JobzShala is India’s No.1 Job Posting <br /> & Recruitment Platform</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="mobile-app-content">
                                    <div className="section-heading margin-bottom-30px">
                                        <h2 className="sec__title font-size-20">JobzShala Job Posting Services - Get Quality Applies</h2>
                                        <p className='sec__desc line-height-22 font-size-16'>Reach out to millions of jobseekers and hire quickly with our fast and easy job posting services.</p>
                                    </div>
                                    <ul className="info-list contact-links">
                                        <li className="d-flex align-items-center mb-2">
                                            <span className="flex-shrink-0 la la-clock-o"></span>
                                            <div className="app-title-box">
                                                <h4 className="widget-title pb-2 font-weight-normal">2 Minutes to Post</h4>
                                            </div>
                                        </li>
                                        <li className="d-flex align-items-center mb-2">
                                            <span className="flex-shrink-0 la la-file-text-o"></span>
                                            <div className="app-title-box">
                                                <h4 className="widget-title pb-2 font-weight-normal">Unlimited Applies</h4>
                                            </div>
                                        </li>
                                        <li className="d-flex align-items-center mb-2">
                                            <span className="flex-shrink-0 la la-users"></span>
                                            <div className="app-title-box">
                                                <h4 className="widget-title pb-2 font-weight-normal"> Attract Audience</h4>
                                            </div>
                                        </li>
                                        <li className="d-flex align-items-center mb-4">
                                            <span className="flex-shrink-0 la la-calendar"></span>
                                            <div className="app-title-box">
                                                <h4 className="widget-title pb-2 font-weight-normal"> 30 Day Visibility</h4>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="btn-box d-flex text-left margin-top-40px">
                                        <a href={constant.component.JobPosting.url} className="theme-btn download-btn">Read More <i className="la la-arrow-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="mobile-img mobile-img-index">
                                    <img src={'./assets/images/mobile-2.png'} alt="mobile-img" />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <section className="solutions__section">
                    <div className="wrapper">
                        <div className="heading">Hiring is now simple</div>
                        <div className="container">
                            <div className="solutions__section container__item row ">
                                <div className="container__item--heading col-md-6">
                                    <div className="title">
                                        <img className="img-number" src={work01} alt="" />
                                        <p className="title_text">Get access to High-Quality Tech Talent</p>
                                    </div>
                                    <div className="subtitle">
                                        Post a job in minutes and get your job in front of the relevant
                                        candidates quickly
                                    </div>
                                </div>
                                <div className="container__item--image col-md-6">
                                    <img
                                        src={work04}
                                        className="one animate"
                                        alt="illustration"
                                    />
                                </div>
                            </div>
                            <div className="solutions__section container__item reverse row">
                                <div className="container__item--heading col-md-6">
                                    <div className="title">
                                        <img className="img-number" src={work02} alt="" />
                                        <p className="title_text">Easily Screen Candidates</p>
                                    </div>
                                    <div className="subtitle">
                                        Save time spent on screening candidates while our Machine Learning
                                        algorithms do the heavy lifting of sorting applications relevant to
                                        your job posting
                                    </div>
                                </div>
                                <div className="container__item--image col-md-6">
                                    <img
                                        src={work05}
                                        className=" reverse-animate"
                                        alt="illustration"
                                    />
                                </div>
                            </div>
                            <div className="solutions__section container__item ">
                                <div className="container__item--heading">
                                    <div className="title">
                                        <img className="img-number" src={work03} alt="" />
                                        <p className="title_text">Use Smart Tools</p>
                                    </div>
                                    <div className="subtitle">
                                        Tools like chat, video/audio calls, interview scheduler help you in
                                        reducing the manual work and connect with the candidates easily and
                                        efficiently
                                    </div>
                                </div>
                                <div className="container__item--image">
                                    <img
                                        src={work06}
                                        className=" animate"
                                        alt="illustration"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="form-shared padding-top-150px padding-bottom-100px">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 mx-auto text-center">
                                <div className='forgot-password'>
                                    <img src={'./assets/images/forgot-pasword.png'} />
                                </div>
                            </div>
                            <div className="col-lg-6 mx-auto">
                                <div className="user-action-form">
                                    <div className="tab-content" id="myTabContent">
                                        <div className="tab-pane fade show active" id="signup-nav" role="tabpanel" aria-labelledby="signup-tab">
                                            <div className="billing-form-item mb-0">
                                                <div className="billing-title-wrap border-bottom-0">
                                                    <h3 className="widget-title font-size-28 pb-2">Forgot Password</h3>
                                                </div>
                                                <div className="billing-content">
                                                    <div className="contact-form-action">
                                                        <form onSubmit={this.onSubmit}>
                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className="input-box">
                                                                        <label className="label-text">Forgot Password <span className='text-danger'>*</span></label>
                                                                        <div className="form-group">
                                                                            <i className="la la-user form-icon"></i>
                                                                            <input
                                                                                className={EMAIL.error.length ? "form-control is-invalid" : "form-control"}
                                                                                type="email"
                                                                                name={EMAIL.name}
                                                                                value={EMAIL.value}
                                                                                onChange={this.onChange}
                                                                                placeholder="Enter Username/Email ID" />
                                                                        </div>
                                                                    </div>
                                                                    <Link to={constant.component.login.url} className='font-size-12'>Go back to Employer's Login page</Link>
                                                                </div>
                                                            </div>
                                                            <div className="btn-box margin-top-30px">
                                                                <button className="theme-btn border-0" type="submit">SUBMIT</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

                <div className="section-block"></div>

            </React.Fragment>
        )
    }
}
